import { api_GET, api_POST, api_PUT } from './_api';

const certificado_api = {
    GetListTipoDocumento: () => {
        const promise = new Promise((resolve, reject) => {
            api_GET("Certificado/GetList/TipoDocumento")
                .then(result => resolve(result))
                .catch(result => reject(result));
        });
        return promise;
    },
    GetList: (tipo_documento) => {
        const promise = new Promise((resolve, reject) => {
            api_GET(`Certificado/GetList/${tipo_documento}`)
                .then(result => resolve(result))
                .catch(result => reject(result));
        });
        return promise;
    },
    GetItem: (id) => {
        const promise = new Promise((resolve, reject) => {
            api_GET(`Certificado/GetItem/${id}`)
                .then(result => resolve(result))
                .catch(result => reject(result));
        });
        return promise;
    },
    EmitirCertificado: (filtros) => {
        const promise = new Promise((resolve, reject) => {
            api_POST("Certificado/EmitirCertificado", filtros)
                .then(result => resolve(result))
                .catch(result => reject(result));
        });
        return promise;
    },
    Post: (obj) => {
        const promise = new Promise((resolve, reject) => {
            api_POST("Certificado", obj)
                .then(result => resolve(result))
                .catch(result => reject(result));
        });
        return promise;
    },
    Put: (obj) => {
        const promise = new Promise((resolve, reject) => {
            api_PUT("Certificado", obj)
                .then(result => resolve(result))
                .catch(result => reject(result));
        });
        return promise;
    },
}
export default certificado_api;